import { Box } from "@chakra-ui/layout";
import { Flex } from "@chakra-ui/react";
import { useState } from "react";
import PageHeader from "components/Page/PageHeader";
import DashboardEncomenda from "./components/DashboardEncomenda/DashboardEncomenda";
import { AiOutlinePlus } from "react-icons/ai";
import ModalCadastrarEncomenda from "./components/ModalCadastrarEncomenda/index";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import ModalFiltroEncomenda from "./components/ModalFiltroEncomenda/index";
import useFiltroEncomenda from "./components/ListaEncomendaTable/hooks/useFiltroEncomenda";
import { useListarEncomenda } from "core/features/encomenda/hooks/useListarEncomenda";
import moment from "moment";
import ModalHistoricoEncomenda from "./components/ModalHistoricoEncomenda/index";
import ModalHistoricoAtualEncomenda from "./components/ModalHistoricoAtualEncomenda/index";
import ListaEncomendaTable from "./components/ListaEncomendaTable/index";
import CalendarioEncomenda from "./../CalendarioEncomenda/index";
import DateRangePicker from "components/Input/DateRangePicker";
import useExcluirEncomenda from "core/features/encomenda/hooks/useExcluirEncomenda";
import { showConfirm } from "infra/helpers/alerta";
import { useLoading } from "components/GlobalLoading";

function ListaEncomenda() {
  const [view, setView] = useState<"CALENDARIO" | "LISTA">("LISTA");
  const { filtro, onChangeFiltro } = useFiltroEncomenda();
  const { data, isLoading, isFetching, refetch } = useListarEncomenda({
    ...filtro,
    limit: view === "CALENDARIO" ? 9999 : filtro.limit,
  });
  const { mutate: excluirEncomenda, isLoading: isLoadingDelete } =
    useExcluirEncomenda();

  const { tenant } = useCurrentTenant();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalFiltros, setIsOpenModalFiltros] = useState(false);
  const [idEncomendaHistorico, setIdEncomendaHistorico] = useState<
    string | undefined
  >();
  const [idEncomendaHistoricoAtual, setIdEncomendaHistoricoAtual] = useState<
    string | undefined
  >();

  const numeroFiltroSelecionados =
    (filtro.pessoaId?.length ? 1 : 0) + (filtro.unidadeId?.length ? 1 : 0);

  useLoading(isLoadingDelete);

  return (
    <>
      <PageHeader
        title="Encomendas"
        mb="24px"
        titleButton="Cadastrar Nova"
        onClick={() => setIsOpenModal(true)}
        buttonProps={{
          leftIcon: (
            <Flex mr={-4}>
              <AiOutlinePlus />
            </Flex>
          ),
        }}
        extraButtonTitle="Filtros avançados"
        extraButtonOnClick={() => setIsOpenModalFiltros(true)}
        badge={true}
        badgeValueExtraButton={numeroFiltroSelecionados}
        midComponent={
          <Flex>
            <DateRangePicker
              onChange={(dataInicio, dataFim) => {
                onChangeFiltro({
                  dataInicio,
                  dataFim,
                });
              }}
              value={{
                dataInicio: filtro.dataInicio,
                dataFim: filtro.dataFim,
              }}
            />
          </Flex>
        }
      />

      <DashboardEncomenda filtro={filtro} onChangeFiltro={onChangeFiltro} />

      <Box>
        {view === "LISTA" ? (
          <ListaEncomendaTable
            sorter={(value?: string, direction?: string) =>
              onChangeFiltro({ orderBy: value, orderDirection: direction })
            }
            filtro={filtro}
            data={data}
            onChangeFiltro={onChangeFiltro}
            isLoading={isLoading || isFetching}
            setIdEncomendaHistorico={setIdEncomendaHistorico}
            setIdEncomendaHistoricoAtual={setIdEncomendaHistoricoAtual}
            onChangeView={() => setView("CALENDARIO")}
            view="LISTA"
            onDeleteEncomenda={(id) => {
              showConfirm("Deseja realmente excluir essa encomenda?").then(
                ({ isConfirmed }) => {
                  if (isConfirmed) {
                    excluirEncomenda(id, {
                      onSuccess: () => refetch?.(),
                    });
                  }
                }
              );
            }}
          />
        ) : (
          <CalendarioEncomenda
            encomendas={data?.items}
            onChangeDate={(start, end) => {
              onChangeFiltro({
                dataInicio: moment(start).format("YYYY-MM-DD"),
                dataFim: moment(end).format("YYYY-MM-DD"),
              });
            }}
            onClick={(v) => setIdEncomendaHistoricoAtual(v.id)}
            onChangeView={() => setView("LISTA")}
            view="CALENDARIO"
            filtro={filtro}
            onChangeFiltro={onChangeFiltro}
            loading={isLoading || isFetching}
          />
        )}
      </Box>

      <ModalCadastrarEncomenda
        visible={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onSaved={() => {
          setIsOpenModal(false);
        }}
        refetchList={refetch}
      />

      <ModalFiltroEncomenda
        filtro={filtro}
        tenantId={tenant.id}
        visible={isOpenModalFiltros}
        onClose={() => setIsOpenModalFiltros(false)}
        onChangeFiltro={onChangeFiltro}
      />

      <ModalHistoricoEncomenda
        onClose={() => setIdEncomendaHistorico(undefined)}
        id={idEncomendaHistorico}
        isOpenModal={!!idEncomendaHistorico}
      />

      <ModalHistoricoAtualEncomenda
        onClose={() => setIdEncomendaHistoricoAtual(undefined)}
        id={idEncomendaHistoricoAtual}
        isOpenModal={!!idEncomendaHistoricoAtual}
        refetchList={refetch}
        onDeleteEncomenda={(id) => {
          showConfirm("Deseja realmente excluir essa encomenda?").then(
            ({ isConfirmed }) => {
              if (isConfirmed) {
                excluirEncomenda(id, {
                  onSuccess: () => {
                    refetch?.();
                    setIdEncomendaHistoricoAtual(undefined);
                  },
                });
              }
            }
          );
        }}
      />
    </>
  );
}

export default ListaEncomenda;
